/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-23T16:11:31.638
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getChanneltagEditInit,
	getChanneltagView
} from '@api/rentmanage/Channeltag';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getChanneltagEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getChanneltagEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getChanneltagView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getChanneltagView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
